<template>
  <div class="fu-drtab" data-test="fu-drawer-family-claims">
    <p v-if="!items.length" class="fu-drtab__empty" data-test="fu-drawer-family-claims-empty">No outstanding claims for this family.</p>
    <div v-for="(it, i) in items" :key="i" class="fu-drtab__item">
      <div class="fu-drtab__main">
        <div class="fu-drtab__item-title">{{ it.title }}</div>
        <div v-if="it.meta" class="fu-drtab__meta">{{ it.meta }}</div>
      </div>
      <div class="fu-drtab__right"><strong>{{ it.right }}</strong><small>Ins est</small></div>
    </div>
  </div>
</template>

<script>
/**
 * DrawerFamilyClaimsTab — "Family claims": today's Outstanding Claims for Family (balances only):
 * Patient, ClaimSent, DateService, ProceduresAttached, InsuranceEstimate. The patient name is shown as
 * loaded (masked at the data boundary). Presentational.
 */
export default {
  name: 'DrawerFamilyClaimsTab',
  props: {
    tab: { type: Object, required: true },
    ctx: { type: Object, required: true },
  },
  computed: {
    items() {
      const s = (this.tab.sections || [])[0];
      const c = this.ctx;
      return ((s && s.rows) || []).map(r => ({
        title: r.Patient || 'Family member',
        meta: [r.ClaimSent ? `Sent ${c.formatDate(r.ClaimSent)}` : '', r.DateService ? `DOS ${c.formatDate(r.DateService)}` : '', r.ProceduresAttached || '']
          .filter(Boolean).join(' · '),
        right: r.InsuranceEstimate === null || r.InsuranceEstimate === undefined ? '—' : c.formatMoney(r.InsuranceEstimate),
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
@import './drawer';

.fu-drtab__empty { @include fu-dr-empty; }
.fu-drtab__item { @include fu-dr-item; }
.fu-drtab__main { flex: 1; min-width: 0; }
.fu-drtab__item-title { @include fu-dr-item-title; }
.fu-drtab__meta { @include fu-dr-item-meta; }

.fu-drtab__right {
  flex: none;
  text-align: right;
  strong { @include fu-tabular; display: block; font-size: 14px; font-weight: 800; }
  small { display: block; margin-top: 1px; font-size: 12px; color: $fu-text-muted; }
}
</style>
